export const TAB_IDS = ['exports', 'builder', 'schedules', 'board', 'pstn'];

// The permission each tab's requests need (the API's ExportData, ViewReports, ManageReports and ManageBilling policies).
export const TAB_PERMISSIONS = {
  exports: 'analytics:export_data',
  builder: 'analytics:view_reports',
  schedules: 'reports:manage',
  board: 'analytics:export_data',
  pstn: 'account:manage_billing',
};

/** The tabs the signed-in role can use, in order. */
export const allowedTabs = (hasPermission) => TAB_IDS.filter((id) => hasPermission(TAB_PERMISSIONS[id]));
